import { useProjectContext } from 'context/ProjectContext'
import { REACT_APP_BACK_END_URL } from 'config'

/**
 * returns the current project and baseURL for report urls
 */
export function useReportURLDependencies() {
  const { projectId } = useProjectContext()
  return { projectId, baseURL: REACT_APP_BACK_END_URL }
}
